export const AUTH_METHOD_STORAGE_KEY = "auth_method";
